import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

// Connects to data-controller="steps-to-reproduce"
export default class extends Controller {
  static targets = ['list', 'template', 'row']

  connect() {
    new Sortable(this.listTarget, {
      handle: '.sortablejs-handle',
      animation: 150
    })
  }

  addStep(event) {
    event.preventDefault()
    this.listTarget.append(this.templateTarget.content.cloneNode(true))
  }

  removeStep(event) {
    event.preventDefault()
    if (this.rowTargets.length <= 1) return

    this.rowTargets.find(row => row.contains(event.target)).remove()
    this._refreshListNumbers()
  }

  _refreshListNumbers() {
    // CSS counters don't recount automatically when DOM elements are removed.
    // Remove and re-add the class to force counter-reset recalculation.
    this.listTarget.classList.remove('list-number-circled')
    setTimeout(() => this.listTarget.classList.add('list-number-circled'))
  }
}
